'use strict';

//Simulate for Admin
 export const Data = 'Search'; 
 export const Admin = 'Search'; 
 export const Search = 'Search';
 export const Publish = 'Search';
